import React from "react";
import { getDecodedToken } from "../../utils/functions";
import SettingsStore from "../../store/SettingsStore";
import ProfileImage from "../ProfileImage/ProfileImage";
import UserStore from "../../store/UserStore";
import arrowDownGolden from "../../assets/images/svg/arrowDownGolden.svg";

const ProfileMenuButton = ({ userDetails }) => {
  const decodedToken = getDecodedToken();

  const getDefaultImage = (name) => {
    if (!name) return;
    return <div className="profileImageDefault2">{name[0]}</div>;
  };

  return (
    <div
      aria-label={`${userDetails.name} ${userDetails.role || ""}`}
      className="nav_profile_container"
    >
      <div aria-hidden={true} className="profile_wrapper">
        {decodedToken?.user_type === "employee" ? (
          getDefaultImage(decodedToken?.full_name)
        ) : decodedToken?.user_type === "manager" &&
          !SettingsStore.liaisonOfficerImages?.[
            SettingsStore.liaisonOfficerData?.profile?.user_id
          ] ? (
          getDefaultImage(getDecodedToken()?.full_name)
        ) : decodedToken?.user_type === "manager" &&
          SettingsStore.liaisonOfficerImages?.[
            SettingsStore.liaisonOfficerData?.profile?.user_id
          ] ? (
          <ProfileImage
            url={
              SettingsStore.liaisonOfficerImages?.[
                SettingsStore.liaisonOfficerData?.profile?.user_id
              ]
            }
          />
        ) : UserStore.currentFamilyMembers?.find(
            (item) => item.user_id === UserStore.selectedUsersId,
          )?.profile_pic && UserStore?.singleUsersUrl ? (
          <ProfileImage url={UserStore?.singleUsersUrl} />
        ) : (
          getDefaultImage(UserStore.userData?.full_name)
        )}
        <div className="profile_details">
          <p className="user_name">{userDetails.name}</p>
          <p className="user_role">{userDetails.role}</p>
        </div>
      </div>
      <div>
        <img aria-hidden={true} src={arrowDownGolden} alt="down" />
      </div>
    </div>
  );
};

export default ProfileMenuButton;
